<script setup lang="ts">
/**
 * App 專屬轉換橫幅 (Conversion Engine)
 * 1. 針對行動端使用者強化「App 專屬費率 (Mobile Rates)」的心理暗示
 * 2. 結合 ScholarTrip 品牌光暈效果 (Glow Strategy)
 * 3. 完美適配折疊手機與超寬平板佈局
 */
</script>
<template>
  <section class="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-32">
    <div
      class="bg-slate-950 rounded-[3rem] p-10 md:p-20 text-white flex flex-col lg:flex-row justify-between items-center gap-16 relative overflow-hidden shadow-[0_40px_100px_-20px_rgba(0,0,0,0.5)]"
    >
      <!-- 裝飾性光暈：建立 Super App 的科技感 -->
      <div
        class="absolute -right-20 -top-20 w-96 h-96 bg-brand-600/20 rounded-full blur-[120px]"
      ></div>
      <div
        class="absolute -left-20 -bottom-20 w-80 h-80 bg-action-600/10 rounded-full blur-[100px]"
      ></div>
      <!-- 文案區 -->
      <div class="max-w-xl relative z-10 text-center lg:text-left">
        <div
          class="inline-flex items-center gap-2 bg-brand-600/20 border border-brand-500/30 px-4 py-2 rounded-full mb-8"
        >
          <span class="w-2 h-2 rounded-full bg-brand-500 animate-ping"></span>
          <span
            class="text-[10px] font-black uppercase tracking-[0.2em] text-brand-400"
            >Mobile Exclusive Perks</span
          >
        </div>
        <h2
          class="text-5xl md:text-8xl font-black mb-8 tracking-tighter leading-none italic uppercase"
        >
          Unified <br />
          <span class="text-brand-500">Super App</span>
        </h2>
        <p
          class="text-slate-400 mb-12 text-lg md:text-xl font-medium leading-relaxed"
        >
          Unlock an additional
          <span
            class="text-white font-black underline decoration-action-500 decoration-4 underline-offset-4"
            >15% off</span
          >
          with student-only mobile rates. Track your unified timeline on the go.
        </p>
        <div class="flex flex-wrap justify-center lg:justify-start gap-4">
          <button
            class="w-48 h-16 bg-white/5 border border-white/10 rounded-2xl flex items-center justify-center hover:bg-white/10 transition group shadow-xl"
          >
            <Icon
              name="logos:apple-app-store"
              class="h-8 w-auto grayscale brightness-200 group-hover:grayscale-0 transition-all"
            />
          </button>
          <button
            class="w-48 h-16 bg-white/5 border border-white/10 rounded-2xl flex items-center justify-center hover:bg-white/10 transition group shadow-xl"
          >
            <Icon
              name="logos:google-play-icon"
              class="h-7 w-auto grayscale group-hover:grayscale-0 transition-all"
            />
          </button>
        </div>
      </div>
      <!-- QR Code 與 手機交互視覺區 -->
      <div class="relative group shrink-0">
        <div
          class="w-72 h-72 bg-white p-10 rounded-[4rem] shadow-2xl relative z-10 rotate-3 group-hover:rotate-0 transition-transform duration-700"
        >
          <div
            class="w-full h-full bg-slate-950 rounded-3xl flex items-center justify-center border-4 border-slate-100 shadow-inner relative overflow-hidden"
          >
            <!-- 模擬 QR Code 網格 -->
            <div
              class="grid grid-cols-4 grid-rows-4 gap-2 w-32 h-32 opacity-20"
            >
              <div v-for="i in 16" :key="i" class="bg-white rounded-sm"></div>
            </div>
            <Icon
              name="ph:qr-code-bold"
              class="absolute text-8xl text-white opacity-90"
            />
          </div>
        </div>
        <!-- 後方動態裝飾 -->
        <div
          class="absolute -inset-6 border-2 border-dashed border-white/10 rounded-[5rem] animate-[spin_20s_linear_infinite]"
        ></div>
      </div>
    </div>
  </section>
</template>
